const config = {
    basename: '/console',
};
export default config;



// WEBPACK FOOTER //
// ./src/config/prod.js